"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Just renders an image
 */
var ui = require("../ui");
var utils = require("../../common/utils");
var React = require("react");
var csx = require("../base/csx");
/**
 * ViewerJS
 * https://github.com/fengyuanchen/viewerjs
 */
var Viewer = require('viewerjs/dist/viewer');
require('viewerjs/dist/viewer.css');
require('./imageViewer.css');
var ImageViewer = /** @class */ (function (_super) {
    __extends(ImageViewer, _super);
    function ImageViewer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ImageViewer.prototype.componentDidMount = function () {
        var root = this.refs['img'];
        var viewer = new Viewer(root, {
            toolbar: true,
            inline: true,
            navbar: false,
            button: false,
            movable: false,
        });
        this.disposible.add({
            dispose: function () { return viewer.destroy(); }
        });
    };
    ImageViewer.prototype.render = function () {
        var filePath = this.props.filePath;
        return React.createElement("div", { style: csx.extend(csx.flex, csx.centerCenter), onClick: this.props.onClick },
            React.createElement("img", { ref: "img", style: { opacity: 0 }, src: utils.imageUrl + "/" + filePath }));
    };
    return ImageViewer;
}(ui.BaseComponent));
exports.ImageViewer = ImageViewer;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/imageViewer/imageViewer.js
 ** module id = 401
 ** module chunks = 0
 **/